import { render, staticRenderFns } from "./SpecialRecursiveComponent.vue?vue&type=template&id=5fcc45ec&scoped=true&"
import script from "./SpecialRecursiveComponent.vue?vue&type=script&lang=js&"
export * from "./SpecialRecursiveComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpecialRecursiveComponent.vue?vue&type=style&index=0&id=5fcc45ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc45ec",
  null
  
)

export default component.exports